import { createAction } from 'redux-actions';
export const SET_CURRENT_LEG = 'SET_CURRENT_LEG';
export const GO_TO_NEXT_LEG = 'GO_TO_NEXT_LEG';
export const setCurrentLeg = createAction(SET_CURRENT_LEG, (legId) => legId);
export const goToNextLeg = createAction(GO_TO_NEXT_LEG);
